import React, { FC } from 'react'

import { Page } from 'common'
import { ErrorHandler, Header } from 'components'
import { isEmpty } from 'lodash'
import { Routes } from 'common/constants'

import { EntityMenuView } from './EntityMenuView'
import { useEntityMenu } from '../hooks/useEntityMenu'
import { EntityMenuSkeleton } from './EntityMenuSkeleton'

export const EntityMenu: FC = () => {
  const {
    title,
    content,
    entities,
    showBottomsheet,
    rightIcon,
    traceDetails,
    isError,
    isLoading,
    onClick,
    bottomsheetClickHandler,
  } = useEntityMenu()

  if (isLoading) return <EntityMenuSkeleton />

  if (isError || isEmpty(content) || isEmpty(entities) || !onClick) {
    return (
      <ErrorHandler
        traceDetails={traceDetails}
        componentName={EntityMenu.name}
        goTo={Routes.LEAVE_TO_APP}
      />
    )
  }

  return (
    <Page>
      <Header title={title} rightIcon={rightIcon} ticScreen={EntityMenuView.name} leaveToApp />

      <EntityMenuView
        infoBottomsheet={content.headerSection.infoBottomsheet}
        bottomsheetClickHandler={bottomsheetClickHandler}
        showBottomsheet={showBottomsheet}
        entities={entities}
        menuOptions={content.menuSection}
        onClick={onClick}
      />
    </Page>
  )
}
